// Fabric-tab filtering for fabric-colour-picker-v2. Clicking a fabric tab
// shows only that family's colour swatches (client-side, no reload), keeps
// ungrouped swatches always visible, updates the "Fabric:" label, and
// remembers the choice in localStorage. Colour selection itself is a radio
// consumed by the shared listener in component-configuration-picker-v2.js.
(function () {
  function storageKey(root) {
    return 'fc-v2:group:' + (root.getAttribute('data-product-id') || 'p');
  }

  // Space-padded contains check — same idiom used for data-fc-groups.
  function inList(list, handle) {
    return (' ' + (list || '').trim() + ' ').indexOf(' ' + handle + ' ') !== -1;
  }

  // The currently-selected sofa handle, or null when the product has no
  // sofa rows (backward-compatible: the whole cascade is skipped then).
  function getSelectedSofa(root) {
    var sel = root.querySelector('.fc-v2__sofa-row--selected');
    if (sel) return sel.getAttribute('data-fc-sofa');
    var checked = root.querySelector('.fc-v2__sofa-input:checked');
    if (checked) {
      var row = checked.closest('.fc-v2__sofa-row');
      if (row) return row.getAttribute('data-fc-sofa');
    }
    return null;
  }

  function getVariants() {
    var el = document.querySelector('[data-v2-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  // Map a sofa handle back to its raw option value — variant.optionN stores the
  // raw value ("Eclipse Sofa"), not the handle.
  function sofaValueFor(root, sofaHandle) {
    var input = root.querySelector('.fc-v2__sofa-row[data-fc-sofa="' + sofaHandle + '"] .fc-v2__sofa-input');
    return input ? input.value : null;
  }

  // Mark visible swatches / tray pills that have no available variant under the
  // current (sofa, colour) scope as unavailable + disabled.
  function refreshAvailability(root) {
    var variants = getVariants();
    if (!variants.length) return;
    var sofaPos = root.getAttribute('data-fc-sofa-position');
    var trayPos = root.getAttribute('data-fc-tray-position');
    var anyColInput = root.querySelector('.fc-v2__swatch-input');
    var colPos = anyColInput ? anyColInput.getAttribute('data-option-position') : null;
    var sofa = getSelectedSofa(root);
    var sofaVal = sofa ? sofaValueFor(root, sofa) : null;

    function hasAvail(pred) {
      return variants.some(function (v) { return v.available && pred(v); });
    }

    if (colPos) {
      root.querySelectorAll('.fc-v2__swatch').forEach(function (sw) {
        if (sw.hidden) return;
        var input = sw.querySelector('.fc-v2__swatch-input');
        if (!input) return;
        var ok = hasAvail(function (v) {
          return v['option' + colPos] === input.value &&
            (!sofaVal || v['option' + sofaPos] === sofaVal);
        });
        sw.classList.toggle('fc-v2__swatch--unavailable', !ok);
        input.disabled = !ok;
      });
    }

    if (trayPos) {
      var checkedColour = root.querySelector('.fc-v2__swatch-input:checked');
      var colourVal = checkedColour ? checkedColour.value : null;
      root.querySelectorAll('.fc-v2__tray-pill').forEach(function (p) {
        if (p.hidden) return;
        var input = p.querySelector('.fc-v2__tray-input');
        if (!input) return;
        var ok = hasAvail(function (v) {
          return v['option' + trayPos] === input.value &&
            (!colourVal || v['option' + colPos] === colourVal) &&
            (!sofaVal || v['option' + sofaPos] === sofaVal);
        });
        p.classList.toggle('fc-v2__tray-pill--unavailable', !ok);
        input.disabled = !ok;
      });
    }
  }

  // Show swatches whose data-fc-groups contains `handle` (or that have no
  // group — ungrouped colours are never hidden). Returns the swatch to
  // auto-select: prefer the first colour that actually belongs to this family,
  // falling back to the first visible (ungrouped) one.
  function filterSwatches(root, handle, sofa) {
    var firstMember = null, firstVisible = null;
    root.querySelectorAll('.fc-v2__swatch').forEach(function (sw) {
      var groups = (sw.getAttribute('data-fc-groups') || '').trim();
      var sofaOk = !sofa || inList(sw.getAttribute('data-fc-sofa'), sofa);
      var isMember = groups !== '' && inList(groups, handle);
      var show = sofaOk && (groups === '' || isMember);
      sw.hidden = !show;
      if (show) {
        if (!firstVisible) firstVisible = sw;
        if (isMember && !firstMember) firstMember = sw;
      }
    });
    return firstMember || firstVisible;
  }

  function activate(root, handle, persist) {
    var tabs = root.querySelectorAll('.fc-v2__tab');
    // Confirm the handle matches a real tab before mutating anything.
    var matched = false;
    tabs.forEach(function (t) { if (t.getAttribute('data-fc-group') === handle) matched = true; });
    if (!matched) return;

    tabs.forEach(function (t) {
      var on = t.getAttribute('data-fc-group') === handle;
      t.classList.toggle('fc-v2__tab--selected', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) {
        var label = root.querySelector('[data-fc-fabric-label]');
        if (label) label.textContent = t.getAttribute('data-fc-group-name') || label.textContent;
      }
    });

    var firstVisible = filterSwatches(root, handle, getSelectedSofa(root));

    // If the currently-checked colour is now hidden (belongs to another
    // family), select the first visible colour so the shown set always has an
    // active swatch. Dispatch `change` so the shared variant listener updates.
    var checked = root.querySelector('.fc-v2__swatch-input:checked');
    var checkedSwatch = checked ? checked.closest('.fc-v2__swatch') : null;
    if ((!checked || (checkedSwatch && checkedSwatch.hidden)) && firstVisible) {
      var input = firstVisible.querySelector('.fc-v2__swatch-input');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Keep the fabric-info modal in step with the picker's fabric selection.
    activateFabricInfo(handle);

    if (persist) {
      try { localStorage.setItem(storageKey(root), handle); } catch (e) {}
    }

    refreshAvailability(root);
  }

  // Sofa cascade: selecting a sofa re-scopes the weave tabs, colour swatches
  // and tray pills to that sofa, auto-selects a valid colour + tray, and
  // dispatches ONE `change` so the shared listener resolves the full
  // (sofa, colour, tray) variant. UI-only weave selection lives here too.
  function activateSofa(root, sofa) {
    // 1. Toggle sofa row selection.
    root.querySelectorAll('.fc-v2__sofa-row').forEach(function (row) {
      var on = row.getAttribute('data-fc-sofa') === sofa;
      row.classList.toggle('fc-v2__sofa-row--selected', on);
      var input = row.querySelector('.fc-v2__sofa-input');
      if (input) input.checked = on;
    });

    // 2. Is the currently-checked colour valid for this sofa? If so we keep it
    //    (page-load re-scope / no-op); if not we'll switch (real sofa change).
    var checkedColour = root.querySelector('.fc-v2__swatch-input:checked');
    var checkedSwatch = checkedColour ? checkedColour.closest('.fc-v2__swatch') : null;
    var colourBelongs = checkedSwatch && inList(checkedSwatch.getAttribute('data-fc-sofa'), sofa);

    // 3. Filter weave tabs to this sofa; hide the whole row when ≤1 family.
    var fabricRow = root.querySelector('.fc-v2__fabric');
    var visibleTabs = [];
    root.querySelectorAll('.fc-v2__tab').forEach(function (t) {
      var show = inList(t.getAttribute('data-fc-sofa'), sofa);
      t.hidden = !show;
      if (show) visibleTabs.push(t);
    });
    if (fabricRow) fabricRow.classList.toggle('fc-v2__fabric--hidden', visibleTabs.length <= 1);

    // Active family: the checked colour's family when we're keeping it, else
    // the sofa's first visible family.
    var weave = visibleTabs.length ? visibleTabs[0].getAttribute('data-fc-group') : '';
    if (colourBelongs) {
      var g = (checkedSwatch.getAttribute('data-fc-groups') || '').trim().split(' ')[0];
      if (g) weave = g;
    }

    // 4. Reflect weave selection + label; filter colours by (sofa, weave).
    root.querySelectorAll('.fc-v2__tab').forEach(function (t) {
      var on = t.getAttribute('data-fc-group') === weave;
      t.classList.toggle('fc-v2__tab--selected', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) {
        var label = root.querySelector('[data-fc-fabric-label]');
        if (label) label.textContent = t.getAttribute('data-fc-group-name') || label.textContent;
      }
    });
    var firstColour = filterSwatches(root, weave, sofa);

    // 5. Filter tray pills to this sofa; lock when only one; keep current tray
    //    if it is still valid, else fall back to the first visible tray.
    var visibleTrays = [];
    root.querySelectorAll('.fc-v2__tray-pill').forEach(function (p) {
      var show = inList(p.getAttribute('data-fc-sofa'), sofa);
      p.hidden = !show;
      p.classList.remove('fc-v2__tray-pill--locked');
      if (show) visibleTrays.push(p);
    });
    var checkedTray = root.querySelector('.fc-v2__tray-input:checked');
    var checkedTrayPill = checkedTray ? checkedTray.closest('.fc-v2__tray-pill') : null;
    var trayToSelect = (checkedTrayPill && !checkedTrayPill.hidden) ? checkedTrayPill : (visibleTrays[0] || null);
    // A sofa with a single tray (e.g. Eclipse → Charred Ash) still shows the
    // pill, marked --locked (selected, non-interactive) rather than hidden.
    if (visibleTrays.length === 1) visibleTrays[0].classList.add('fc-v2__tray-pill--locked');
    var trayChanged = false;
    root.querySelectorAll('.fc-v2__tray-pill').forEach(function (p) {
      var on = p === trayToSelect;
      p.classList.toggle('fc-v2__tray-pill--selected', on);
      var input = p.querySelector('.fc-v2__tray-input');
      if (input) {
        if (on && !input.checked) trayChanged = true;
        input.checked = on;
      }
    });

    // 6. Keep the checked colour when still valid; otherwise switch to the first
    //    colour in scope. Dispatch ONE change only when something changed, so a
    //    page-load re-scope does not trigger a needless variant refetch. A
    //    colour change alone resolves the whole (sofa, colour, tray) variant.
    var dispatched = false;
    var colourStillValid = checkedSwatch && !checkedSwatch.hidden;
    if (!colourStillValid && firstColour) {
      var colourInput = firstColour.querySelector('.fc-v2__swatch-input');
      if (colourInput) {
        colourInput.checked = true;
        colourInput.dispatchEvent(new Event('change', { bubbles: true }));
        dispatched = true;
      }
    }
    if (!dispatched && trayChanged && trayToSelect) {
      var ti = trayToSelect.querySelector('.fc-v2__tray-input');
      if (ti) ti.dispatchEvent(new Event('change', { bubbles: true }));
    }

    try { localStorage.setItem(storageKey(root) + ':sofa', sofa); } catch (e) {}

    refreshAvailability(root);
  }

  // Fabric-info modal (fabric-info-modal-v2.liquid): show the panel for `handle`
  // (matched by data-fabric on the tab/panel) and update the title. Used both by
  // the picker sync above and the modal's own tab clicks (browsing). No-op when
  // no panel matches, so a fabric family without a block leaves the modal as-is.
  function activateFabricInfo(handle) {
    document.querySelectorAll('[data-fabric-info]').forEach(function (modal) {
      var panels = modal.querySelectorAll('[data-fabric-info-panel]');
      var matched = null;
      panels.forEach(function (p) { if (p.getAttribute('data-fabric') === handle) matched = p; });
      if (!matched) return;
      panels.forEach(function (p) { p.hidden = p !== matched; });
      modal.querySelectorAll('[data-fabric-info-tab]').forEach(function (t) {
        var on = t.getAttribute('data-fabric') === handle;
        t.classList.toggle('fc-v2-info__tab--selected', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var titleEl = modal.querySelector('[data-fabric-info-title]');
      if (titleEl) titleEl.textContent = matched.getAttribute('data-fabric-name') || titleEl.textContent;
    });
  }

  // Fabric-swatch modal: show only the insight panel for the checked colour
  // (matched by data-fc-colour on the swatch → data-fc-insight on the panel).
  // Falls back to the first panel when the selected colour has no insight.
  function syncInsight(root) {
    var dlg = root.querySelector('[data-fc-swatch-dialog]');
    if (!dlg) return;
    var checked = root.querySelector('.fc-v2__swatch-input:checked');
    var swatch = checked ? checked.closest('.fc-v2__swatch') : null;
    var handle = swatch ? swatch.getAttribute('data-fc-colour') : null;
    var panels = dlg.querySelectorAll('[data-fc-insight]');
    var shown = null;
    panels.forEach(function (p) {
      var match = p.getAttribute('data-fc-insight') === handle;
      p.hidden = !match;
      if (match) shown = p;
    });
    if (!shown) {
      panels.forEach(function (p, i) { p.hidden = i !== 0; });
    }
  }

  function init(root) {
    var tabs = root.querySelectorAll('.fc-v2__tab');
    if (tabs.length) {
      // Tab clicks are handled by the delegated document listener below (so they
      // survive the Section Rendering API swap in component-configuration-picker-v2.js,
      // which replaces this picker's DOM without re-running init). Here we only
      // restore the server-selected tab, falling back to localStorage when the
      // server rendered nothing selected.
      if (!root.querySelector('.fc-v2__tab--selected')) {
        var saved = null;
        try { saved = localStorage.getItem(storageKey(root)); } catch (e) {}
        if (saved) activate(root, saved, false);
      }
    }

    // Scope the picker to the currently-selected sofa on load: hides other
    // sofas' weave tabs / colours / trays and applies the single-family +
    // single-tray states. activateSofa keeps the server-selected colour when
    // it is valid, so this does NOT trigger a variant refetch on load. No-op
    // when the product has no sofa rows — backward compatible.
    var sofa = getSelectedSofa(root);
    if (sofa) activateSofa(root, sofa);

    // Keep the fabric-swatch modal panel in sync with the colour choice on load
    // (ongoing sync is handled by the delegated change listener below). Independent
    // of fabric tabs — a single-family product still has a modal.
    if (root.querySelector('[data-fc-swatch-dialog]')) {
      syncInsight(root);
    }

    refreshAvailability(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fabric-colour-picker]').forEach(init);
  }

  // Picker tab clicks: switch the active fabric family. Delegated (not bound
  // per-button in init) so it keeps working after component-configuration-picker-v2.js
  // replaces the picker's DOM on a colour/variant refetch — the swapped-in tabs
  // carry no per-element listeners, and shopify:section:load never fires for that swap.
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.fc-v2__tab');
    if (!tab) return;
    var root = tab.closest('[data-fabric-colour-picker]');
    if (root) activate(root, tab.getAttribute('data-fc-group'), true);
  });

  // Sofa selection: re-scope the whole picker. Delegated `change` (not click) so
  // it runs deterministically after the shared resolver in
  // component-configuration-picker-v2.js (loaded first) on the same event — the
  // resolver's initial no-match run is a harmless no-op, then activateSofa fixes
  // the colour/tray and dispatches the change that resolves the real variant.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('fc-v2__sofa-input')) return;
    var root = input.closest('[data-fabric-colour-picker]');
    var row = input.closest('.fc-v2__sofa-row');
    if (root && row) activateSofa(root, row.getAttribute('data-fc-sofa'));
  });

  // Keep the fabric-swatch modal panel in sync with the colour choice. Delegated
  // for the same reason: the per-root listener would be lost on the DOM swap.
  document.addEventListener('change', function (e) {
    if (!(e.target && e.target.classList && e.target.classList.contains('fc-v2__swatch-input'))) return;
    var root = e.target.closest('[data-fabric-colour-picker]');
    if (!root) return;
    if (root.querySelector('[data-fc-swatch-dialog]')) syncInsight(root);
    refreshAvailability(root);
  });

  // Fabric-info modal: clicking an in-modal tab browses to that fabric (does not
  // change the picker selection). Delegated so it works for any section instance.
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-fabric-info-tab]');
    if (tab) activateFabricInfo(tab.getAttribute('data-fabric'));
  });

  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  // component-configuration-picker-v2.js swaps the whole .mp-v2 section on a
  // colour/variant refetch (Section Rendering API) WITHOUT firing
  // shopify:section:load, so init never re-runs and the JS-applied sofa scope
  // (hidden other-sofa tabs, single-family hide, tray scope/lock) would be lost
  // on the fresh server markup. Re-scope on the variant:change it dispatches
  // after the swap. init's activateSofa keeps the server-selected colour when
  // valid, so this re-scope does not re-dispatch a change (no refetch loop).
  document.addEventListener('variant:change', function () { initAll(document); });
})();
